import React from 'react';

const OnwardIcon = () => (
  <svg
    width={180}
    height={180}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      style={{ display: 'none' }}
      cx="17.9999"
      cy="17.9999"
      r="17.4276"
      transform="rotate(-45 17.9999 17.9999)"
      fill="#D1B9E3"
      stroke="#0A3887"
      strokeWidth="0.5"
    />
    <g clipPath="url(#clip0_1400_125)">
      <path
        d="M17.9994 27.9999C14.6914 27.9999 12 25.3738 12 22.1448C12 18.9159 14.6914 16.291 17.9994 16.291C21.3073 16.291 24 18.9172 24 22.1448C24 25.3725 21.3086 27.9999 17.9994 27.9999ZM17.9994 16.7384C14.9436 16.7384 12.4573 19.1645 12.4573 22.1448C12.4573 25.1252 14.9436 27.5525 17.9994 27.5525C21.0551 27.5525 23.5415 25.1265 23.5415 22.1448C23.5415 19.1632 21.0551 16.7384 17.9994 16.7384Z"
        fill="#0A3887"
      />
      <path
        d="M17.9994 25.994C15.8251 25.994 14.0558 24.2676 14.0558 22.1461C14.0558 20.0245 15.8251 18.2982 17.9994 18.2982C20.1737 18.2982 21.9429 20.0245 21.9429 22.1461C21.9429 24.2676 20.1737 25.994 17.9994 25.994ZM17.9994 18.7456C16.0773 18.7456 14.5144 20.2706 14.5144 22.1461C14.5144 24.0215 16.0773 25.5465 17.9994 25.5465C19.9215 25.5465 21.4844 24.0215 21.4844 22.1461C21.4844 20.2706 19.9215 18.7456 17.9994 18.7456Z"
        fill="#0A3887"
      />
      <path
        d="M17.8732 16.7906L13.6278 13.8252V7.99994H22.1186V13.8252L17.8732 16.7906ZM14.0864 13.5953L17.8732 16.2401L21.6601 13.5953V8.44736H14.0864V13.5953Z"
        fill="#0A3887"
      />
      <path
        d="M16.2251 15.6224C16.099 15.6224 15.9958 15.5217 15.9958 15.3986V8.22365C15.9958 8.10061 16.099 7.99994 16.2251 7.99994C16.3512 7.99994 16.4543 8.10061 16.4543 8.22365V15.3986C16.4543 15.5217 16.3512 15.6224 16.2251 15.6224Z"
        fill="#0A3887"
      />
      <path
        d="M19.5215 15.6224C19.3954 15.6224 19.2922 15.5217 19.2922 15.3986V8.22365C19.2922 8.10061 19.3954 7.99994 19.5215 7.99994C19.6476 7.99994 19.7508 8.10061 19.7508 8.22365V15.3986C19.7508 15.5217 19.6476 15.6224 19.5215 15.6224Z"
        fill="#0A3887"
      />
    </g>
    <defs>
      <clipPath id="clip0_1400_125">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(3 3)"
        />
      </clipPath>
      <clipPath id="clip1_1400_125">
        <rect
          width={12}
          height={20}
          fill="white"
          transform="translate(12 8)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default OnwardIcon;
